import React from "react";
import "./footer.css";
import { Container, Row, Col, ListGroup, ListGroupItem } from "reactstrap";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <Container>
        <Row>
          <Col lg="3">
            <h5 className="footer__link-title">About Us</h5>
            <p style={{ textAlign: "justify" }}>
              Jai Jyoti Tours and Travel Sole Prop. delivers exceptional travel
              experiences tailored to customer needs, ensuring comfort, quality,
              and memorable journeys through personalized tours focused on
              customer satisfaction.
            </p>
          </Col>

          <Col lg="3">
            <h5 className="footer__link-title">Reach Us</h5>
            <ListGroup className="footer__quick-links">
              <ListGroupItem className="ps-0 border-0 d-flex align-items-start gap-3">
                <span>
                  <i className="ri-map-pin-line"></i>
                </span>
                <div>
                  <p className="mb-0">
                    Reg. Office - Shop No -3, Lal Man Building, Railway Station,
                    NH 5, near Taradevi, Taradevi, Shimla, Himachal Pradesh
                    171010
                  </p>
                </div>
              </ListGroupItem>
              <ListGroupItem className="ps-0 border-0 d-flex align-items-start gap-3">
                <span>
                  <i className="ri-map-pin-line"></i>
                </span>
                <div>
                  <p className="mb-0">
                    Corporate Office - Care of JP Sharma, Jai Jyoti Tour &
                    Travels,Taradevi, Shimla 171010
                  </p>
                </div>
              </ListGroupItem>
            </ListGroup>
          </Col>

          <Col lg="3">
            <h5 className="footer__link-title">Contact Us</h5>
            <ListGroup className="footer__quick-links">
              <ListGroupItem className="ps-0 border-0 d-flex align-items-center gap-3">
                <span>
                  <i className="ri-phone-fill"></i>
                </span>
                <div>
                  <p className="mb-0">+91 94597 89190</p>
                  <p className="mb-0">+91 70189 84511</p>
                </div>
              </ListGroupItem>
              <ListGroupItem className="ps-0 border-0 d-flex align-items-center gap-3">
                <span>
                  <i className="ri-mail-line"></i>
                </span>
                <div>
                  <p className="mb-0">jpsharma704@gmail.com</p>
                </div>
              </ListGroupItem>
            </ListGroup>
          </Col>

          <Col lg="3">
            <h5 className="footer__link-title">Follow Us</h5>
            <ListGroup className="footer__quick-links">
              <ListGroupItem className="ps-0 border-0 d-flex align-items-center gap-3">
                <span>
                  <i className="ri-facebook-circle-line"></i>
                </span>
                <p className="mb-0">Facebook</p>
              </ListGroupItem>
              <ListGroupItem className="ps-0 border-0 d-flex align-items-center gap-3">
                <span>
                  <i className="ri-instagram-line"></i>
                </span>
                <p className="mb-0">Instagram</p>
              </ListGroupItem>
            </ListGroup>
          </Col>

          <Col
            lg="12"
            className="d-flex justify-content-between align-items-center pt-4"
          >
            <p className="copyright mb-0">
              ©Jai Jyoti Tour & Travels Sole Prop. {year}
            </p>
            <p className="developed-by mb-0">
              (Designed and Developed by Sadhishtha Developers pvt. ltd)
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
